// extracted by mini-css-extract-plugin
export default {"spacedRows":"styles_spacedRows__Gaxvi","teamTitle":"styles_teamTitle__glmGM","dropDownSearchBox":"styles_dropDownSearchBox__DiJqt","contentTable":"styles_contentTable__oj8jz"};